<div class="font-inter flex flex-col gap-4 px-5 py-6">
  <p class="text-[20px] font-medium leading-[24px] text-[#022d35]">
    @if (data.employeeName; as name) {
      {{ 'pages.security.end_session_dialog.employee_title' | translate: { name } }}
    } @else {
      {{ 'pages.security.end_session_dialog.title' | translate }}
    }
  </p>

  <p class="text-[14px] font-normal leading-[20px] text-[#6e707d]">
    @if (data.employeeName; as name) {
      {{ 'pages.security.end_session_dialog.employee_message' | translate: { name } }}
    } @else if (data.isCurrentDevice) {
      {{ 'pages.security.end_session_dialog.message' | translate }}
    } @else {
      {{ 'pages.security.end_session_dialog.message_other' | translate }}
    }
  </p>

  <div class="bg-[#f5f7f7] rounded-[6px] px-[14px] py-[12px] flex flex-col gap-1">
    <p class="text-[14px] font-medium leading-[18px] text-[#022d35]">{{ data.device }}</p>
    <p class="text-[12px] font-normal leading-[16px] text-[#6e707d]">
      {{ data.location }} &middot; {{ 'pages.security.end_session_dialog.signed_in' | translate }} {{ data.signedInAt }}
    </p>
  </div>

  <div class="flex flex-col gap-2 mt-1">
    <button
      type="button"
      mat-dialog-close
      class="w-full border border-solid border-[#e7eaeb] rounded-[4px] py-[10px] text-[14px] font-medium leading-[18px] text-[#616f74] bg-white">
      {{ 'common.buttons.cancel' | translate }}
    </button>
    <button
      type="button"
      (click)="confirm()"
      class="w-full bg-[#a31927] rounded-[4px] py-[10px] text-[14px] font-medium leading-[18px] text-white">
      @if (data.isCurrentDevice) {
        {{ 'pages.security.active_sessions.end_and_sign_out' | translate }}
      } @else {
        {{ 'pages.security.active_sessions.end_session' | translate }}
      }
    </button>
  </div>
</div>
